<template>
	<div>
		<LightboxBase class="mobile" :close="close">
			<h2>🚨 Bacha!</h2>
			<p>Právě vstupujete na neprobádané území. Pro kvalitní zážitek s hledáním filmů ve vašem oblébeném kině doporučujeme stáhnout aplikaci ArtKina pro váš chytrý telefon.</p>
			<ul>
				<li><a href="http://bit.ly/akgpweb" target="_blank">🤖&nbsp;&nbsp;ArtKina pro Android</a></li>
				<li><a href="http://bit.ly/aiosweb" target="_blank">🍎&nbsp;&nbsp;ArtKina pro iOS</a></li>
			</ul>
			<p>Bez okolků přiznáváme, že jsme mobilní verzi <strong>Moje Artkina</strong> nevěnovali tolik pozornosti a péče, protože naše hlavní úsilí směřujeme do aplikací pro Android, iOS a Desktop. Proto může být zážitek z používání <strong>Moje Artkina</strong> poněkud trpký...</p>
			<ul>
				<li><a href="http://bit.ly/akgpweb" target="_blank">🤖&nbsp;&nbsp;ArtKina pro Android</a></li>
				<li><a href="http://bit.ly/aiosweb" target="_blank">🍎&nbsp;&nbsp;ArtKina pro iOS</a></li>
			</ul>
		</LightboxBase>
	</div>
</template>

<script>
import LightboxBase from './LightboxBase.vue'

export default {
	components: { LightboxBase },
	computed: {
		close: () => () => {
			document.querySelector('html').classList.remove('lightbox--active')
			document.querySelector('html').classList.remove('lightbox--active-mobile')
			const nextWeek = (new Date()).getTime() + (7 * 24 * 3600 * 1000)
			localStorage.setItem('mobilePopup', nextWeek)
		}
	},
	methods: {}
}
</script>

<style lang=less>
	@import "../../assets/less/default.less";

	html.lightbox--active.lightbox--active-mobile {
		#lightbox.mobile { display: none; }
		@media @mobile { display: block;
			#lightbox.mobile { display: block; max-width: 100%; max-height: 100%; }
		}
	}
	#lightbox.mobile {
		.lightbox__content {
			@media @mobile { width: 90vw; margin-top: 1em; }
			.lightbox__wrapper--inner { padding: 2em;
				h2 { font-size: 2rem; }
				h3 { font-size: 1.2rem; }
				p, ul { margin-bottom: 1em; }
				a { text-decoration: none; color: @red; font-weight: bold; font-size: 1.1rem; }
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/lightbox/LightboxMobile.vue